import {
  IsOptional,
  IsEnum,
  IsUUID,
  IsEmail,
  IsDateString,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import {
  EmailStatus,
  EmailPriority,
  EmailTemplateType,
  EmailCategory,
} from '../../../enums'

/**
 * DTO for listing emails with filters
 */
export class ListEmailsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ enum: EmailStatus })
  @IsEnum(EmailStatus)
  @IsOptional()
  status?: EmailStatus

  @ApiPropertyOptional({ enum: EmailPriority })
  @IsEnum(EmailPriority)
  @IsOptional()
  priority?: EmailPriority

  @ApiPropertyOptional({ enum: EmailCategory })
  @IsEnum(EmailCategory)
  @IsOptional()
  category?: EmailCategory

  @ApiPropertyOptional({ enum: EmailTemplateType })
  @IsEnum(EmailTemplateType)
  @IsOptional()
  templateType?: EmailTemplateType

  @ApiPropertyOptional({ description: 'Filter by recipient email' })
  @IsEmail()
  @IsOptional()
  recipient?: string

  @ApiPropertyOptional({ description: 'Filter by campaign ID' })
  @IsUUID()
  @IsOptional()
  campaignId?: string

  @ApiPropertyOptional({ description: 'Filter by establishment ID' })
  @IsUUID()
  @IsOptional()
  establishmentId?: string

  @ApiPropertyOptional({ description: 'Filter by sender ID' })
  @IsUUID()
  @IsOptional()
  senderId?: string

  @ApiPropertyOptional({
    description: 'Date de début de recherche (ISO 8601)',
    example: '2025-01-01T00:00:00Z',
  })
  @IsDateString()
  @IsOptional()
  startDate?: string

  @ApiPropertyOptional({
    description: 'Date de fin de recherche (ISO 8601)',
    example: '2025-01-31T23:59:59Z',
  })
  @IsDateString()
  @IsOptional()
  endDate?: string
}
